import React, { useState, useEffect } from 'react';
import { FaHome, FaRulerCombined, FaMoneyBillWave, FaPenAlt, FaCheckCircle, FaGem } from 'react-icons/fa';
import { servicesData } from '../data/servicesData';
import '../styles/HireDesigner.css';

const HireDesigner = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        service: 'Hire Interior Designer',
        message: 'I would like to hire an interior designer for my project.'
    });

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Prepare data for SheetDB
        const formDataForApi = {
            name: formData.name || '',
            email: formData.email || '',
            phone: formData.phone,
            service: formData.service,
            msg: formData.message || ''
        };

        try {
            const response = await fetch('https://sheetdb.io/api/v1/yeglfi70ssbxg', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data: [formDataForApi]
                })
            });

            const result = await response.json();

            if (response.ok) {
                setIsSubmitted(true);
                // Reset form
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    service: 'Hire Interior Designer',
                    message: 'I would like to hire an interior designer for my project.'
                });
            } else {
                throw new Error(result.error || 'Failed to submit form');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('There was an error submitting your request. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isSubmitted) {
        return (
            <div className="hire-designer-container">
                <div className="success-container">
                    <div className="diamond-icon">
                        <FaGem />
                    </div>
                    <div className="success-icon">
                        <FaCheckCircle />
                    </div>
                    <h2>Thank You for Your Interest!</h2>
                    <p>We've received your request to hire an interior designer. Our team will contact you within 24 hours to discuss your project in detail.</p>
                    <button
                        className="back-button"
                        onClick={() => setIsSubmitted(false)}
                    >
                        Submit Another Request
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="hire-designer-container">
            <div className="hire-hero">
                <div className="hero-content">
                    <h1 >Hire an Expert Interior Designer</h1>
                    <p>Transform your space with our professional design services tailored to your style and needs.</p>
                </div>
            </div>

            <div className="hire-content">
                <div className="hire-form-container">
                    <div className="form-wrapper">
                        <h2>Tell Us About Your Project</h2>
                        <form onSubmit={handleSubmit} className="hire-form">
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Your Name (Optional)"
                                    value={formData.name}
                                    onChange={handleChange}
                                    aria-label="Your Name"
                                />
                            </div>

                            <div className="form-group">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email Address (Optional)"
                                    value={formData.email}
                                    onChange={handleChange}
                                    aria-label="Email Address"
                                />
                            </div>

                            <div className="form-group">
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder="Phone Number*"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                    aria-label="Phone Number"
                                />
                            </div>

                            <div className="form-group">
                                <select
                                    name="service"
                                    value={formData.service}
                                    onChange={handleChange}
                                    className="service-select"
                                    aria-label="Service Type"
                                >
                                    <option value="Hire Interior Designer">Hire Interior Designer</option>
                                    {servicesData.map(service => (
                                        <option key={service.id} value={service.title}>
                                            {service.title}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <textarea
                                    name="message"
                                    placeholder="Tell us about your project requirements, preferred style, and any specific needs..."
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows="4"
                                    required
                                    aria-label="Project Details"
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                className="submit-button"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Submitting...' : 'Hire a Designer'}
                            </button>
                        </form>
                    </div>
                </div>

                <div className="hire-benefits">
                    <h2>Why Choose Our Designers?</h2>
                    <div className="benefits-grid">
                        <div className="benefit-card">
                            <div className="benefit-icon">🎨</div>
                            <h3>Creative Solutions</h3>
                            <p>Innovative designs tailored to your unique style and space requirements.</p>
                        </div>
                        <div className="benefit-card">
                            <div className="benefit-icon">🏆</div>
                            <h3>Experienced Team</h3>
                            <p>Certified designers with years of industry experience.</p>
                        </div>
                        <div className="benefit-card">
                            <div className="benefit-icon">💡</div>
                            <h3>End-to-End Service</h3>
                            <p>From concept to completion, we handle every detail.</p>
                        </div>
                        <div className="benefit-card">
                            <div className="benefit-icon">💰</div>
                            <h3>Transparent Pricing</h3>
                            <p>No hidden costs with flexible budget options.</p>
                        </div>
                    </div>

                    <div className="cta-box">
                        <h3>Not Sure Where to Start?</h3>
                        <p>Schedule a free consultation with our design experts to discuss your project.</p>
                        <button
                            className="profile-btn"
                            onClick={() => {

                            }}
                        >
                            Book Free Consultation
                        </button>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default HireDesigner;
